/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

/**
 * This component is the documentation section for the Teams Sync Setup.
 */
export const TeamsSyncSetupDocumentation = () => {
	return (
		<>
			<div style={{ margin: "20px" }}>
				<div>
					In order to properly setup Team Status Syncing from Microsoft Teams to Amazon Connect, the following steps are
					required:
				</div>
				<div style={{ marginTop: "20px" }}>
					<div style={{ marginTop: "10px", display: "flex" }}>
						<h6 style={{ marginRight: "5px" }}>1.</h6>
						<h6>Create an Azure Active Directory App Registration for PACE.</h6>
					</div>
					<div style={{ marginLeft: "50px" }}>For the redirect URL, enter 'http://localhost:5000'.</div>
					<div style={{ marginTop: "10px", display: "flex" }}>
						<h6 style={{ marginRight: "5px" }}>2.</h6>
						<h6>Open the new App Registration and do the following:</h6>
					</div>
					<div style={{ marginLeft: "50px" }}>
						<div>Retrieve the Tenant ID and Client ID for the application.</div>
						<div style={{ marginTop: "10px" }}>Under 'Certificates and secrets' create a new Client Secret.</div>
						<div style={{ marginTop: "10px" }}>
							Under 'API Permissions' add the following delegated permissions: 'Presence.Read.All' and 'User.Read'.
						</div>
					</div>
					<div style={{ marginTop: "10px", display: "flex" }}>
						<h6 style={{ marginRight: "5px" }}>3.</h6>
						<h6>Create a service account and assign it the Azure PACE App Registration.</h6>
					</div>
					<div style={{ marginLeft: "50px" }}>
						Due to the way Microsoft Graph API is currently implemented; PACE will need to login using this user’s
						credentials to query user statuses.
					</div>
					<div style={{ marginTop: "10px", display: "flex" }}>
						<h6 style={{ marginRight: "5px" }}>4.</h6>
						<h6>Configure and use the following URI to login as the service account user.</h6>
					</div>
					<div style={{ marginLeft: "50px" }}>
						<div style={{ backgroundColor: "lightGray", wordBreak: "break-all", padding: "5px" }}>
							{
								"https://login.microsoftonline.com/{TENANT_ID}/oauth2/v2.0/authorize?client_id={CLIENT_ID}&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A5000&response_mode=query&scope=https%3A%2F%2Fgraph.microsoft.com%2FPresence.Read.All&state=12345"
							}
						</div>
						<div style={{ marginTop: "10px", display: "flex" }}>
							<h6 style={{ marginRight: "5px" }}>NOTE:</h6>
							<div>
								{"Replace '{TENANT_ID}' and '{CLIENT_ID}' with the values for your PACE Azure App Registration"}
							</div>
						</div>
						<div>This will grant the user the necessary permissions needed for Teams Status Syncing.</div>
					</div>
					<div style={{ display: "flex", marginTop: "10px" }}>
						<h6 style={{ marginRight: "5px" }}>5.</h6>
						<h6>
							Enter the information that you have gathered in the previous steps into the form on the 'Configuration'
							tab.
						</h6>
					</div>
					<div style={{ display: "flex" }}>
						<h6 style={{ marginRight: "5px" }}>6.</h6>
						<h6>
							To enable Team Status Sync for a user, enter the user’s Azure Active Directory ID in the user’s profile on
							the PACE User Management Page.
						</h6>
					</div>
				</div>
			</div>
		</>
	);
};
